<template>
  <div id="gridWrapper">
    <div class="columns">
      <page-general-text
        v-if="showGeneralText"
        :pageId="page.id"
        :bundleId="page.bundle.id"
        @close="toggleGeneralText">
      </page-general-text>
    </div>

    <div class="columns">
      <div
        v-if="selected.length !== 0"
        class="column is-one-fifth has-border-right">

        <div
          class="tile is-ancestor selectable"
          v-for="(item, idx) in selected"
          :key="item.id">

          <div id="generalTextWrapper" class="tile is-parent">
            <router-link
              tag="div"
              class="tile is-child notification"
              :class="colors[idx]"
              :to="route(idx)">

              <p class="title is-size-6">{{ getColumn(item.column_id).tabname }}</p>
              <p class="subtitle is-size-5">{{ item.parsed }}</p>
            </router-link>
          </div>
        </div>
      </div>

      <div v-show="depth < page.columns.length - 1" class="column">
        <div
          class="tile selectable is-ancestor"
          v-for="(values, idx) in rows"
          :key="idx">

          <div
            v-if="depth === 0 && idx === 0 && !showGeneralText && (!isPublic || hasGeneralText)"
            class="tile selectable is-parent">

            <article
              class="tile is-child notification"
              @click="toggleGeneralText">

              <p class="title is-5">Algemeen</p>
              <p>Klik hier voor de toelichting</p>
            </article>
          </div>

          <div
            class="tile selectable is-parent"
            v-for="value in values"
            :key="value.id">

            <page-grid-item
              :value="value"
              :depth="depth"
              :parents="[]"
              :color="colors[depth]">
            </page-grid-item>
          </div>
        </div>
      </div>

      <div v-if="showContent" class="column is-four-fifths">
        <page-content
          :path="path"
          :isGeneralText="false">
        </page-content>
      </div>
    </div>
  </div>
</template>

<script>
import { bus } from '@/main'
import { mapGetters } from 'vuex'
import PageContent from '@/components/pages/PageContent'
import PageGridItem from '@/components/pages/PageGridItem'
import PageGeneralText from '@/components/pages/PageGeneralText'

export default {
  name: 'PageGrid',
  props: {
    showContent: {
      type: Boolean,
      required: true
    }
  },
  components: {
    PageContent,
    PageGridItem,
    PageGeneralText
  },
  data () {
    return {
      rows: [],
      selected: [],
      colors: [
        'is-primary',
        'is-link',
        'is-warning',
        'is-danger',
        'is-info',
        'is-success'
      ],
      showGeneralText: false
    }
  },
  computed: {
    ...mapGetters({
      page: 'pages/page',
      mode: 'pages/mode',
      values: 'values/values',
      isPublic: 'pages/isPublic'
    }),
    path () {
      return (this.$route.params.path) ? this.$route.params.path.split(',').map(id => parseInt(id)) : []
    },
    depth () {
      return this.path.length
    },
    nextColumn () {
      const inc = (this.depth < 2) ? 2 : 1
      return this.page.columns[this.depth + inc]
    },
    hasGeneralText () {
      return this.page && this.page.page_texts.length != 0
    },
    nextLevelIsLeaf () {
      return this.depth === this.page.columns.length - 1
    }
  },
  created () {
    this.init()
  },
  watch: {
    '$route': 'init',
    values () {
      this.selected = this.values
    },
    showContent () {
      if (this.showContent) this.showGeneralText = false
    }
  },
  methods: {
    toggleGeneralText() {
      this.showGeneralText = !this.showGeneralText
    },
    pickColor () {
      return this.colors[Math.floor(Math.random() * this.colors.length)]
    },
    getColumn (columnId) {
      return this.page.columnProperties.find(x => x.id === columnId)
    },
    route (idx) {
      const params = { id: this.page.id }

      if (idx !== 0) {
        params.path = this.path.slice(0, idx).join(',')
      }

      const name = (!this.isPublic) ? 'page' : 'public-page'

      return {
        name: name,
        params: params
      }
    },
    init () {
      this.rows = []

      if (this.path.length !== this.selected.length) {
        this.buildSelection()
      }

      this.fetchChildren()

      if (this.nextLevelIsLeaf) {
        bus.$emit('showContent', {
          path: this.path,
          childColumnId: this.nextColumn
        })
      } else {
        bus.$emit('closeContent')
      }
    },
    buildSelection () {
      if (this.path.length > 0) {
        this.$store.dispatch('values/load', this.path.map(item => item))
      } else {
        this.selected = []
      }
    },
    fetchChildren () {
      let params = {
        path: this.path,
        mode: this.mode,
        depth: this.depth,
        childColumnId: this.page.columns[this.depth]
      }

      if (this.$route.params.code) {
        params.code = this.$route.params.code
      } else {
        params.pageId = this.page.id
        params.bundleId = this.page.bundle.id
      }

      this.$store.dispatch('pages/fetchChildren', params).then(res => {
        this.setValues(res.children)
      })
    },
    setValues (values) {
      let i = 0
      const tilesPerRow = 4

      while (i < values.length) {
        this.rows.push(values.slice(i, i + tilesPerRow))
        i = i + tilesPerRow
      }
    }
  }
}
</script>

<style scoped>
  .selectable {
    cursor: pointer;
  }

  .has-border-right {
    border-right: 1px solid hsl(0, 0%, 86%);
  }
</style>
